import axios from '@/axios'
import API from '@/API'

const PREFIX = 'branch'

export default {
  select() {
    return axios.get(`${API.endpoint}/${PREFIX}/select`)
  },
}